<template>
  <div>
    <Add />
  </div>
</template>

<script>
import Add from "./add.vue";
export default {
  name: "createB2BToB2C",
  components: {
    Add,
  },
  data() {
    return {};
  },
};
</script>

<style>
</style>